var i18nModule = require('./i18n')

if (typeof window !== 'undefined' && !window.__) {
  window.__ = i18nModule.__
  window.i18nUtils = i18nModule.i18nUtils
} else if (typeof global !== 'undefined' && !global.__) {
  global.__ = i18nModule.__
  global.i18nUtils = i18nModule.i18nUtils
}
